import OrganizationLayout from './OrganizationLayout';

export default OrganizationLayout;